let Loot = {
    gems_total: 0,
    gems_sum: 0,
    arts_total: 0,
    arts_sum: 0,
    coins: {
        copper: 0,
        silver: 0,
        electrum: 0,
        gold: 0,
        platinum: 0,
    },
    coins_names: {
        copper: ['медная', 'медных', 'медных'],
        silver: ['серебряная', 'серебряных', 'серебряных'],
        electrum: ['электровая', 'электровых', 'электровых'],
        gold: ['золотая', 'золотых', 'золотых'],
        platinum: ['платиновая', ' платиновых', 'платиновых'],
    },
};

/**
 * Очищает результаты генерации камней
 */
function clearGems() {
    document.getElementById('loot-gems-string').innerHTML = '';
    document.getElementById('loot-gems-list').innerHTML = '';
    Loot.gems_total = 0;
    Loot.gems_sum = 0;
}

/**
 * Очищает результаты генерации произведений искусства
 */
function clearArts() {
    document.getElementById('loot-arts-string').innerHTML = '';
    document.getElementById('loot-arts-list').innerHTML = '';
    Loot.arts_total = 0;
    Loot.arts_sum = 0;
}

/**
 * Очищает результаты генерации монет
 */
function clearCoins() {
    document.getElementById('loot-coins-string').innerHTML = '';
    document.getElementById('loot-coins-list').innerHTML = '';
    Loot.coins = {
        copper: 0,
        silver: 0,
        electrum: 0,
        gold: 0,
        platinum: 0,
    };
}

/**
 * Очищает результаты генерации безделушек
 */
function clearTrinkets() {
    document.getElementById('loot-trinkets-list').innerHTML = '';
}

/**
 * Очищает результаты генерации сокровищницы
 */
function clearTreasury() {
    document.getElementById('loot-treasury-list').innerHTML = '';
}

/**
 * Очищает результаты генерации свитков
 */
function clearScrolls() {
    document.getElementById('loot-scrolls-list').innerHTML = '';
}

/**
 * Очищает результаты генерации предметов
 */
function clearItems() {
    document.getElementById('loot-items-list').innerHTML = '';
}

document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll('[data-request]').forEach(function (elem) {
        elem.addEventListener('click', async function (event) {
            let data = await request(elem);
            if (data.result) {

                let string = '';
                let li;

                switch (data.type) {

                    case 'gems':

                        Loot.gems_total++;
                        Loot.gems_sum += data.price;

                        string = 'Всего <strong>' + Loot.gems_total + '</strong> ' + numEnding(Loot.gems_total, ['камень', 'камня', 'камней']) + ' на сумму <strong>' + (new Intl.NumberFormat('ru-RU').format(Loot.gems_sum)) + '</strong> золотых монет.';
                        document.getElementById('loot-gems-string').innerHTML = string;
                        delete window.string;

                        li = document.createElement('li');
                        li.innerHTML = data.string;
                        document.getElementById('loot-gems-list').prepend(li);

                        break;

                    case 'arts':

                        Loot.arts_total++;
                        Loot.arts_sum += data.price;

                        string = 'Всего <strong>' + Loot.arts_total + '</strong> ' + numEnding(Loot.arts_total, ['произведение', 'произведения', 'произведений']) + ' искусства на сумму <strong>' + (new Intl.NumberFormat('ru-RU').format(Loot.arts_sum)) + '</strong> золотых монет.';
                        document.getElementById('loot-arts-string').innerHTML = string;

                        li = document.createElement('li');
                        li.innerHTML = data.string;
                        document.getElementById('loot-arts-list').prepend(li);

                        break;

                    case 'coins':

                        let total = 0;

                        for (const [key, value] of Object.entries(data.coins)) {
                            Loot.coins[key] += value;

                        }

                        for (const [key, value] of Object.entries(Loot.coins)) {
                            total += value;
                            if (value) {
                                string += '<div class="loot-row"><strong>' + (new Intl.NumberFormat('ru-RU').format(value)) + '</strong> ' + numEnding(value, Loot.coins_names[key]) + ' ' + numEnding(value, ['монета', 'монеты', 'монет']) +
                                    ' (' + (new Intl.NumberFormat('ru-RU').format((value / 50).toFixed(1))) + ' фнт.)</div>';
                            }
                        }

                        string = 'Всего <strong>' + (new Intl.NumberFormat('ru-RU').format(total)) + '</strong> ' + numEnding(total, ['монета', 'монеты', 'монет']) +
                            ' (' + (new Intl.NumberFormat('ru-RU').format((total / 50).toFixed(1))) + ' фнт.):<br>' + string;

                        document.getElementById('loot-coins-string').innerHTML = string;

                        li = document.createElement('li');
                        li.innerHTML = data.string;
                        document.getElementById('loot-coins-list').prepend(li);

                        break;

                    case 'trinkets':

                        li = document.createElement('li');
                        li.innerHTML = data.string;
                        document.getElementById('loot-trinkets-list').prepend(li);

                        break;

                    case 'treasury':

                        li = document.createElement('li');
                        li.innerHTML = data.string;
                        document.getElementById('loot-treasury-list').prepend(li);

                        break;

                    case 'scrolls':

                        li = document.createElement('li');
                        li.innerHTML = data.string;
                        document.getElementById('loot-scrolls-list').prepend(li);

                        break;

                    case 'items':

                        li = document.createElement('li');
                        li.innerHTML = data.string;
                        document.getElementById('loot-items-list').prepend(li);

                        break;

                    default:
                        break;
                }
            }
        });
    });

});